const DefaultToArray = function () {
  return []
}

export default DefaultToArray
